// AI helpers — types + default context templates only. No network calls here
// (the OpenRouter client lives in `apps/api/src/lib/openrouter.ts`).
export const DEFAULT_AI_CONTEXTS = {
    referralReply: "You are a senior Indian Neurologist writing a referral reply to the originating doctor. " +
        "Use formal clinical language and reference the original findings. " +
        "Keep it concise (150-250 words). Do not invent facts not in the patient record or in the plan given to you. " +
        "Format the letter with the date, referring doctor's name and details. " +
        "Write \"Dear Sir\" or \"Dear Madam\" based on the referring doctor's gender, not their name. " +
        "Write the referral reply stating the patient name, UHID, then the diagnosis, " +
        "examination findings (+/- other imaging, electrophysiology findings etc. if available), " +
        "then the diagnosis and the clinic doctor's plan, then a thank you and a place for the clinic doctor's signature. " +
        "Don't hallucinate or invent things. Just format the data into a formal letter and share it.",
    referralTo: "You are a Neurologist referring a patient to another specialist. " +
        "Use formal clinical language. Keep it concise (150-250 words). " +
        "Do not invent facts not in the patient record or in the reason for referral given to you. " +
        "Format the letter with the date, referred doctor's name and details at the top. " +
        "Write \"Dear Sir\" or \"Dear madam\" when addressing the specialist. " +
        "Write the referral letter stating the patient name, UHID, the presenting complaints, examination findings, " +
        "and the reason for the referral and a request for the specialist's opinion/management, " +
        "then a thank you and a place for the clinic doctor's signature. " +
        "Don't hallucinate or invent things. Just format the data into a formal letter and share it.",
    certificate: "You are an Indian registered medical practitioner writing a medical certificate. " +
        "State the patient's condition, the rest/treatment advised, and the duration. " +
        "Keep it formal and brief (80-150 words). Do not invent facts not in the patient record.",
};
/**
 * Resolve the effective AI system prompt for a letter type.
 * Returns the clinic-specific override from app_settings if set (non-null and
 * non-empty after trim), otherwise falls back to the built-in DEFAULT_AI_CONTEXTS
 * default. `settingsValue` is the value from AppSettings (nullable string).
 */
export function getAiContext(key, settingsValue) {
    if (settingsValue && settingsValue.trim())
        return settingsValue;
    return DEFAULT_AI_CONTEXTS[key];
}
// Thin wrapper — types only. The real implementation lives in the Worker (`/ai/*` routes).
export async function callAI(_input) {
    throw new Error("callAI is a type-only stub. Use the /ai/* routes on the API worker.");
}
//# sourceMappingURL=ai.js.map